<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import Loading from "../../../components/widgets/loading.vue"

import { required, helpers } from "@vuelidate/validators";
import {userService} from "@/helpers/authservice/user.service";
import useVuelidate from "@vuelidate/core";
import "@/assets/css/styles.css";

/**
 * Forgot Password component
 */

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    username: {
      required: helpers.withMessage("Username is required.", required),
    },
  },
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loading
  },
  data() {
    return {
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      username : "",
      isLoading: false,
    };
  },
  methods: {

    tryToRest() {

      this.isLoading = true;
      this.submitted = true;
      // stop here if form is invalid
      this.v$.$touch();  

      this.tryingToReset = true;    

      if (this.v$.$invalid) {
        this.tryingToReset = false;
         this.isLoading = false;
        return;
      } else {        
        if (this.username) {
          const forgotrequest = {
            "username": this.username.trim().toUpperCase()
          }
          userService.forgotPassword(forgotrequest)
              .then(() => {
                  this.tryingToReset = true;
                  this.isResetError = false;
                  this.isLoading = false;
              })
              .catch((err) => {
                this.error = err.message;
                this.tryingToReset = false;
                this.isResetError = true;
                this.isLoading = false;
                if(err.validationFailures && err.validationFailures.length > 0 ){
                  this.error = err.validationFailures[0].code.includes('notExist') ? 'Username does not exist.': this.error;
                }
              });
        }
      }
    },
  },
};
</script>

<template>
  <Layout >
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <!-- replace "password" - check condition to show the reset password view -->
          <div class="forgot-pwd-header-container">
            <div class="d-flex justify-content-between">
              <div class="">
                <div class="p-4">
                  <h5 class="forgot-pwd-header">Forgot Password</h5>
                </div>
              </div>              
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="p-2">
              
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ error }}</b-alert
              >

              <form @submit.prevent="tryToReset">

                  <div class="mt-4 mb-3">
                    <label for="loginid">Enter your username</label>
                    <input
                      type="text"
                      v-model="username"
                      class="form-control"
                      placeholder="Enter username"
                      @keydown.space.prevent
                      :class="{
                        'is-invalid': submitted && !tryingToReset && v$.username.$errors,
                      }"
                    />
                    <div
                      v-for="(item, index) in v$.username.$errors"
                      :key="index"
                      class="invalid-feedback error-container"
                    >
                      <span v-if="item.$message">{{ item.$message }}</span>
                    </div>
                  </div>
                
                <div class="mt-4 d-grid">
                  <b-button @click="tryToRest()" class="forgot-password-btn" :disabled="isLoading">
                   <Loading v-if="isLoading" /> <span v-if="!isLoading"> Forgot Password</span></b-button>
                </div>

                <div v-if="this.tryingToReset && !this.isLoading">
                <div class="p-3 reseived-email-box-outer">
                  <div class="d-flex justify-content-between p-3 reseived-email-box">
                      <div class="">
                        <div class="">
                          <label class="reseived-email-box-title">Check your email</label>
                        </div>
                        <div class="">
                          Keep an eye on your inbox! We've just sent instructions to your registered email
                        </div>
                      </div>
                      <div class="align-self-end">
                        <img
                          src="@/assets/images/reseived_email.png"
                          alt
                          class="img-fluid reseived-email-box-img"
                        />
                      </div>                  
                  </div>
                </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
   </Layout>  
</template>

<style lang="scss" scoped>

.reseived-email-box-outer{
  padding: 1rem 0rem 1rem 0rem !important;
}

.reseived-email-box{
  background-color: #e8e8e8;
  box-sizing: border-box;
  padding: 1rem 1rem 1rem 1rem !important;
  border-radius: 0.25rem;
}

.reseived-email-box-title{
  font-weight: 1000;
}

.reseived-email-box-img{
  width: 100px;
}

</style>
